import { useMemo } from "react";
import { JCodeDetails } from "../../../../data-model/medicalPaOrdersModel";

export const useJCodeOptions = (
  jCodes?: JCodeDetails[],
): {
  value: string;
  label: string;
  description: string;
  authStatus: string;
}[] => {
  const jCodeOptions = useMemo(() => {
    return (
      jCodes?.map((jCode: JCodeDetails) => ({
        value: jCode?.id ?? "",
        label: `${jCode?.j_code ?? "N/A"} - ${jCode?.description ?? ""}`,
        description: jCode?.description ?? "",
        authStatus: jCode?.auth_status ?? "",
      })) ?? []
    );
  }, [jCodes]);

  return jCodeOptions ?? [];
};
